import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FinancialReportComponent } from './financial.report.component';
import { CoreService } from '../core/core.service';

const routes: Routes = [
  CoreService.childRoutes([
    { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    { path: 'financialReport', component: FinancialReportComponent, data: { title: 'Financial Report' } },
  ])
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ReportRoutingModule { }
